import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as S from "./styles";
import { useToken } from '../../Components/TokenContext';
import { VendaItens } from '../../Components/VendaItens';

function Vendas() {
    const { tokenData, solicitarVenda } = useToken();
    const navigate = useNavigate();
    const [vendas, setVendas] = useState([]);
    const [error, setError] = useState('');
    const baseUrl = process.env.REACT_APP_API_URL;
    const [loading, setLoading] = useState(true);
    const accessToken = localStorage.getItem('access_token');

    const [vendaData, setVendaData] = useState({
        numero_pedido: '',
        descricao: '',
        data_contrato: '',
    });

    const [userErrorData, setUserErrorData] = useState({
        numero_pedido: [],
        descricao: [],
        data_contrato: [],
    });
    const [formLoading, setFormLoading] = useState(false);


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setVendaData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const fetchMyVendas = async () => {
        try {
            const response = await fetch(`${baseUrl}/vendas`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                setLoading(false);
                setError('Erro ao buscar os suas vendas.');
                return;
            }

            const data = await response.json();
            setVendas(data.vendas);

        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMyVendas();
    }, []);

    const handleSubmit = async (e) => {
        if (tokenData.tipo == 'participante') {
            e.preventDefault();
            setFormLoading(true);
            try {
                const response = await fetch(`${baseUrl}/cadastrar/vendas`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(vendaData)
                });

                const result = await response.json();

                if (!response.ok) {
                    setFormLoading(false);
                    setUserErrorData(result);
                    navigate('/vendas', {
                        state: {
                            message: { type: 'error', text: 'Por favor, verifique o(s) campo(s) sinalizados em vermelho' },
                        },
                    });
                    return;
                }

                setFormLoading(false);
                fetchMyVendas();

                navigate('/vendas', {
                    state: {
                        message: { type: 'success', text: result.message },
                    },
                });

                setVendaData({
                    numero_pedido: '',
                    descricao: '',
                    data_contrato: '',
                });

                setUserErrorData({
                    numero_pedido: [],
                    descricao: [],
                    data_contrato: [],
                });

            } catch (error) {
                setFormLoading(false);
                console.log(error.message);
            }
        }

        return;

    };

    return (
        <S.Container>
            <div>
                <div className="bg-primary">
                    <div className="container max-w-large">
                        <form onSubmit={handleSubmit} className="w-full pb-10">
                            <div className="flex flex-col min-h-[70vh] py-10 justify-center items-center">
                                <h2 className="font-secondary-xt text-4xl 2xl:text-[45px] text-tertiary text-center font-semibold mt-20 mb-6">Cadastrar nova venda</h2>
                                <div className="bg-white rounded-xl p-6 md:p-10 w-full max-w-[600px] 2xl:max-w-[700px]">
                                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                                        <div className="w-full">
                                            <label className="block text-sm font-medium mb-1">Número do pedido</label>
                                            <input
                                                type="text"
                                                disabled={!solicitarVenda}
                                                name="numero_pedido"
                                                value={vendaData.numero_pedido}
                                                onClick={() => setUserErrorData(prevData => ({ ...prevData, numero_pedido: [] }))}
                                                onChange={handleChange}
                                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"

                                            />
                                            {userErrorData.numero_pedido && userErrorData.numero_pedido[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.numero_pedido[0]} <span onClick={() => setUserErrorData(prevData => ({ ...prevData, numero_pedido: [] }))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                                        </div>
                                    </div>

                                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                                        <div className="w-full">
                                            <label className="block text-sm font-medium mb-1">Descrição</label>
                                            <input
                                                type="text"
                                                disabled={!solicitarVenda}
                                                name="descricao"
                                                value={vendaData.descricao}
                                                onClick={() => setUserErrorData(prevData => ({ ...prevData, descricao: [] }))}
                                                onChange={handleChange}
                                                maxLength="20"
                                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                                max={new Date().toJSON().slice(0, 10)}
                                            />
                                            {userErrorData.descricao && userErrorData.descricao[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.descricao[0]} <span onClick={() => setUserErrorData(prevData => ({ ...prevData, descricao: [] }))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                                        </div>

                                    </div>

                                    <div className="mb-3 flex gap-5 lg:gap-15 flex-col lg:flex-row">
                                        <div className="w-full">
                                            <label className="block text-sm font-medium mb-1">Data de contrato</label>
                                            <input
                                                type="date"
                                                disabled={!solicitarVenda}
                                                name="data_contrato"
                                                value={vendaData.data_contrato}
                                                onClick={() => setUserErrorData(prevData => ({ ...prevData, data_contrato: [] }))}
                                                onChange={handleChange}
                                                className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                            />
                                            {userErrorData.data_contrato && userErrorData.data_contrato[0] && (<span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">{userErrorData.data_contrato[0]} <span onClick={() => setUserErrorData(prevData => ({ ...prevData, data_contrato: [] }))} className="rotate-45 -my-2 p-2 cursor-pointer">+</span></span>)}
                                        </div>
                                    </div>

                                    {tokenData.tipo == 'participante' && solicitarVenda == true && (

                                        <button
                                            type="submit"
                                            className="mt-4 w-full bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"

                                        >
                                            {!formLoading ? (
                                                'Cadastrar venda'
                                            ) : (
                                                <div role="status" className="flex justify-center items-center">
                                                    <svg aria-hidden="true" className="w-6 h-6 text-white text-opacity-60 animate-spin fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                    </svg>
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            )}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </form>

                        <h2 className="font-secondary-xt text-4xl 2xl:text-[45px] text-tertiary text-center font-semibold -mt-10 mb-6">Histórico de vendas e pontuação</h2>
                        <p className="text-lg text-center text-white mb-10">A cada cem reais (R$ 100,00) em vendas, você garante quatro (04) pontos do programa Chance Premiada.</p>
                        
                        {tokenData.tipo == 'participante' && (
                            <>
                                {loading ? (
                                    <div className={`flex items-center justify-center transition-opacity duration-300`}>
                                        <div className="mb-12 h-12 w-12 animate-spin rounded-full border-4 border-solid border-tertiary border-t-transparent"></div>
                                    </div>
                                ) : (
                                    vendas && vendas.length > 0 && (
                                        vendas.map((item, k) => (
                                            <div className='vendasContainer space-y-5 pb-20'>
                                                <VendaItens data={item} key={k} />
                                            </div>
                                        ))
                                    )
                                )}
                            </>
                        )}
                    </div>

                    <div className="bg-tertiary py-5">
                        <div className="container max-w-large">
                            <p className="text-primary text-center font-semibold">
                                O período para solicitar seu prêmio é de 01 de janeiro de 2027 até 15 de janeiro de 2027
                            </p>
                            {tokenData.tipo == 'participante' && (
                                <p className="text-primary text-center font-semibold">
                                    Total de pontos válidos: {tokenData.pontosAtuais}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </S.Container>
    );
}

export default Vendas;